var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{attrs:{"action":_vm.url,"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload,"headers":_vm.uploadHeader(),"multiple":false,"accept":_vm.accept,"data":_vm.data}},[_vm._t("uploadContent")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }